/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.ai.rpc.AcademyAIRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const searchQuestionsRpc = {
  serviceName: 'com.hubspot.academy.ai.rpc.AcademyAIRpc',
  rpcName: 'searchQuestions',
  auth: 'app',
  fingerprint: 'MkZexo8XlqnGO1IRePzvvpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitQueryRpc = {
  serviceName: 'com.hubspot.academy.ai.rpc.AcademyAIRpc',
  rpcName: 'submitQuery',
  auth: 'app',
  fingerprint: 'bg5amEKMGo7hAII1OUrxg5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getQueryResultRpc = {
  serviceName: 'com.hubspot.academy.ai.rpc.AcademyAIRpc',
  rpcName: 'getQueryResult',
  auth: 'app',
  fingerprint: 'cF2JGfjDX4943mQhgZtL3JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const removePregeneratedAnswerRpc = {
  serviceName: 'com.hubspot.academy.ai.rpc.AcademyAIRpc',
  rpcName: 'removePregeneratedAnswer',
  auth: 'app',
  fingerprint: 'CFOuSQaY2e8p5xmvzzfL_JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};